import { render, staticRenderFns } from "./JobOrderCreate.vue?vue&type=template&id=bc465760&"
import script from "./JobOrderCreate.vue?vue&type=script&lang=js&"
export * from "./JobOrderCreate.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports